import * as React from 'react';
import { GetMenubar } from '../../../helpers/menubarHelper';
import { MenuList } from './menulist.component';
import styles from './menubar.module.css';

import aboutYou from '../../../images/aboutYou.png';
import goals from '../../../images/goals.png';
// import goalsWhite from '../../../images/goalsWhite.png';
import reviewPlan from '../../../images/reviewPlan.png';
import reviewPlanWhite from '../../../images/reviewPlanWhite.png';
import riskProfile from '../../../images/riskProfile.png';
// import riskProfileWhite from '../../../images/riskProfileWhite.png';
import successWhite from '../../../images/successWhite.png';

import { HeaderComponent } from '../header/header.component';
import { useLead } from '../../../contexts/lead/lead.context';
import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { TLastPageRequest } from '../../../models/last-update-page-request';
import { LeadCategory } from '../../../models/lead-category-enum';
import { LeadApi } from '../../../apis/lead.api';

export type TMenuBarStateProps = {
	updateLastPage: (page: TLastPageRequest) => void;
};

export const MenuBarComponent: React.FC<TMenuBarStateProps> = ({ updateLastPage }) => {
	const location = useLocation();
	const [tabActive, setActiveTab] = React.useState<'about' | 'goals' | 'risk-profile' | 'your-analysis'>('about');
	const { investorNavState, updateNavState, leadProfile, leadProfileId, leadStrategyId, agentId } = useLead();

	useEffect(() => {
		if (
			location.pathname.includes('about') ||
			location.pathname.includes('investment_amount') ||
			location.pathname.includes('investment_reason')
		) {
			setActiveTab('about');
			updateNavState({ ...investorNavState, aboutYouVisited: true });
		}
		if (location.pathname.includes('goals')) {
			setActiveTab('goals');
			updateNavState({ ...investorNavState, aboutYouVisited: true, goalsVisited: true });
		}
		if (location.pathname.includes('risk-profile')) {
			setActiveTab('risk-profile');
			updateNavState({ ...investorNavState, aboutYouVisited: true, goalsVisited: true, riskVisited: true });
		}
		if (location.pathname.includes('your-analysis')) {
			setActiveTab('your-analysis');
			updateNavState({
				...investorNavState,
				aboutYouVisited: true,
				goalsVisited: true,
				riskVisited: true,
				analysisVisited: true,
			});
		}
	}, [location.pathname]);

	useEffect(() => {
		// this will only update SetGoal
		if (investorNavState.goalsVisited) {
			updateLastPage({
				leadId: leadProfileId,
				leadStrategyId: leadStrategyId,
				agentId: agentId,
				lastPageVisited: LeadCategory.SetGoal,
				currentRoute: '',
			});
		}
	}, [investorNavState.goalsVisited]);

	useEffect(() => {
		// this will only update RiskProfile
		if (investorNavState.riskVisited) {
			updateLastPage({
				leadId: leadProfileId,
				leadStrategyId: leadStrategyId,
				agentId: agentId,
				lastPageVisited: LeadCategory.RiskProfile,
				currentRoute: '',
			});
		}
	}, [investorNavState.riskVisited]);

	useEffect(() => {
		// this will only update RiskProfile
		if (investorNavState.analysisVisited) {
			updateLastPage({
				leadId: leadProfileId,
				leadStrategyId: leadStrategyId,
				agentId: agentId,
				lastPageVisited: LeadCategory.YourAnalysis,
				currentRoute: '',
			});
		}
	}, [investorNavState.analysisVisited]);

	const onMenuBarClick = (screen: string): void => {
		LeadApi.redirectToPage$.next(screen);
	};

	return (
		<div className="relative">
			<HeaderComponent />

			<nav className={styles.customNav}>
				<div className={styles.fullWidth}>
					<ul className={styles.menuUl}>
						<MenuList
							img={aboutYou}
							title={`${GetMenubar().About}`}
							activeImg={successWhite}
							tabActive={tabActive === 'about' && true}
							border={true}
							lastVisited={investorNavState.aboutYouVisited}
							click={() => onMenuBarClick('about')}
						/>
						<MenuList
							img={goals}
							activeImg={successWhite}
							title={`${GetMenubar().Goals}`}
							tabActive={tabActive === 'goals' && true}
							border={true}
							lastVisited={investorNavState.goalsVisited}
							click={() =>
								tabActive === 'goals' || investorNavState.goalsVisited
									? onMenuBarClick(
											leadProfile.investmentReason === '3'
												? 'goals/investment_target'
												: 'goals/retirement_age',
									  )
									: null
							}
						/>
						<MenuList
							img={riskProfile}
							activeImg={successWhite}
							title={`${GetMenubar().RiskProfile}`}
							tabActive={tabActive === 'risk-profile' && true}
							border={true}
							lastVisited={investorNavState.riskVisited}
							click={() =>
								tabActive === 'risk-profile' || investorNavState.riskVisited
									? onMenuBarClick('risk-profile/investment_return')
									: null
							}
						/>
						<MenuList
							img={reviewPlan}
							activeImg={successWhite}
							title={`${GetMenubar().YourAnalysis}`}
							tabActive={tabActive === 'your-analysis' && true}
							border={false}
							lastVisited={investorNavState.analysisVisited}
							click={() =>
								tabActive === 'your-analysis' || investorNavState.analysisVisited
									? onMenuBarClick('your-analysis')
									: null
							}
						/>
					</ul>
				</div>
			</nav>
		</div>
	);
};
